module.exports = __webpack_public_path__ + "static/img/home_icon_order.9593283c.png";